module.exports = __webpack_public_path__ + "img/get-it-on-google-play.470024f3.svg";